import React, { useCallback, useState } from "react";
import { Alert, Button, Spin } from "antd";
import { serverFetch } from "@core/server";
import "./check-db-page.css";

const pick = (obj, ...keys) => {
  for (const key of keys) {
    if (obj?.[key] !== undefined && obj?.[key] !== null) return obj[key];
  }
  return undefined;
};

const CheckDbPage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);

  const runCheck = useCallback(() => {
    setLoading(true);
    setError("");
    setResult(null);
    serverFetch("service/check-db", { method: "POST" })
      .then((data) => {
        const zal = pick(data, "sprZalIsGroup", "SprZalIsGroup") || {};
        setResult({
          updatedToGroup: Number(pick(zal, "updatedToGroup", "UpdatedToGroup")) || 0,
          updatedToLeaf: Number(pick(zal, "updatedToLeaf", "UpdatedToLeaf")) || 0,
          updated: Number(pick(zal, "updated", "Updated")) || 0,
          msgTables: pick(data, "msgTables", "MsgTables") || null
        });
      })
      .catch((e) => {
        setError(e.message || "Не удалось выполнить проверку базы");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className="check-db-page">
      <h1 className="check-db-page__title">Проверка базы</h1>
      <p className="check-db-page__desc">
        Синхронизация флага <code>IS_GROUP</code> в таблице кабинетов (<code>SPR_ZAL</code>): группа — если
        есть вложенные элементы, иначе кабинет. При отсутствии таблиц диалогов создаются <code>MSG_*</code>.
      </p>
      <div className="check-db-page__actions">
        <Button type="primary" onClick={runCheck} loading={loading} disabled={loading}>
          Выполнить
        </Button>
      </div>
      {loading ? (
        <div className="check-db-page__center">
          <Spin tip="Выполняется проверка..." />
        </div>
      ) : null}
      {error ? <Alert className="check-db-page__alert" type="error" showIcon message={error} /> : null}
      {result ? (
        <>
          <Alert
            className="check-db-page__alert"
            type="success"
            showIcon
            message="Проверка SPR_ZAL завершена"
            description={
              result.updated === 0
                ? "Все флаги IS_GROUP уже корректны, изменений нет."
                : `Обновлено записей: ${result.updated} (в группу: ${result.updatedToGroup}, в кабинет: ${result.updatedToLeaf}).`
            }
          />
          {result.msgTables ? (
            <Alert
              className="check-db-page__alert"
              type={result.msgTables.created || result.msgTables.Created ? "success" : "info"}
              showIcon
              message="Таблицы диалогов MSG_*"
              description={result.msgTables.message || result.msgTables.Message || ""}
            />
          ) : null}
        </>
      ) : null}
    </div>
  );
};

export default CheckDbPage;
